import InformationModal from '../../shared/components/modal-information';

export default class MentorWelcomeModal extends InformationModal {
  markModalAsRead() {
    $.ajax({
      url: this.$element.data('read-url'),
      type: 'PUT',
      // eslint-disable-next-line camelcase
      data: {user: {welcome_modal_read_at: new Date()}},
      dataType: 'json',
    });
  }
}
